<template lang="pug">
label.label-base
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class LabelBase extends Vue {}
</script>

<style lang="stylus" scoped>
.label-base
  outline none
  cursor pointer
</style>
